module.exports = __webpack_public_path__ + "img/trophy.942c6f2b.svg";